import { useQuery } from "@tanstack/react-query";

import { apiFetch } from "@/lib/api";

export interface PartnerRow {
  account_id: string;
  account_name: string;
  qb_id: number;
  master_type: string | null;
  master_signed_at: string | null;
  master_term_months: number;
  master_mrr_total: number;
  master_effective_from: string | null;
  master_effective_through: string | null;
  industry_name: string | null;
  closer_name: string | null;
  po_count: number;
  po_mrr_total: number;
  company_count: number;
  own_arr: number;
  own_subscription_arr: number;
  sub_arr: number;
  sub_qb_count: number;
  current_arr: number;
  current_subscription_arr: number;
  arr_12mo_ago: number;
  arr_ytd_start: number;
  run_rate_arr: number;
  arr_t12m_delta: number;
  arr_ytd_delta: number;
  partner_level: string;
  billing_status: string | null;
  months_since_billing: number | null;
  last_billed_period: string | null;
  last_3_periods_billing: number;
  current_period: string;
  period_12mo_ago: string;
  this_year_start_period: string;
}

export function usePartners() {
  return useQuery({
    queryKey: ["partners", "list"],
    queryFn: () => apiFetch<{ rows: PartnerRow[] }>("/partners"),
  });
}

export interface PartnerDetail {
  purchase_orders: Array<Record<string, unknown>>;
  companies: Array<Record<string, unknown>>;
  billing_history: Array<{
    period: string;
    total_arr: number;
    subscription_arr: number;
    run_rate_arr: number;
    run_rate_subscription_arr: number;
  }>;
  sub_links: Array<{
    link_id: string | null;
    sub_qb_id: number;
    effective_period: string | null;
    name: string;
    is_orphan: boolean;
    last_period: string | null;
    last_sub_mrr: number;
  }>;
}

export function usePartnerDetail(accountId: string) {
  return useQuery({
    queryKey: ["partners", "detail", accountId],
    queryFn: () => apiFetch<PartnerDetail>(`/partners/${accountId}`),
    enabled: !!accountId,
  });
}
